import React from 'react';
import { getDesignVersion } from './designVersionConfig';

type VersionedPageProps<P = Record<string, never>> = {
    pageId: string;
    v1: React.ComponentType<P>;
    v2?: React.ComponentType<P>;
    pageProps?: P;
};

export const VersionedPage = <P extends object = Record<string, never>>({
    pageId,
    v1: V1,
    v2: V2,
    pageProps,
}: VersionedPageProps<P>) => {
    const version = getDesignVersion(pageId);

    if (version === 'v2' && V2) {
        return <V2 {...(pageProps as P)} />;
    }
    return <V1 {...(pageProps as P)} />;
};
